// extracted by mini-css-extract-plugin
export var galleryContainer = "Gallery-module--galleryContainer--cuhNo";
export var gallery = "Gallery-module--gallery--2oLbd";
export var galleryPic = "Gallery-module--galleryPic--2Nmyn";
export var caption = "Gallery-module--caption--11ES3";
export var landscape = "Gallery-module--landscape--3VKqq";
export var portrait = "Gallery-module--portrait--3RdDN";
export var loading = "Gallery-module--loading--1MRlO";
export var header = "Gallery-module--header--1fu6a";